<template>
  <mdbRow class="mt-3">
    <mdbCol col="12">
      <p v-html="getBenefitTitle()"></p>
    </mdbCol>
    <mdbCol col="12">
      <p v-html="getBenefitText()"></p>
    </mdbCol>
    <mdbCol col="12">
      <p v-html="getRestrictionText()"></p>
    </mdbCol>
    <mdbCol class="text-center" col="12">
      <p style="font-weight:700" v-html="getCodeText()"></p>
    </mdbCol>
    <mdbCol class="text-center" col="12">
      <p v-html="getValidityText()"></p>
    </mdbCol>
    <mdbCol class="text-center" col="12">
      <p v-if="benefit.barcode.length > 0">
      Etuun oikeuttava viivakoodi tulee näkyviin käyttäessäsi edun kassalla.
      </p>
    </mdbCol>
    <mdbCol col="12">
      <mdbRow>
      <mdb-btn class="cs-pink" block size="sm">{{
        getBenefitButtonText()
      }}</mdb-btn>
      </mdbRow>
      <hr />
    </mdbCol>
  </mdbRow>
</template>

<script>
import { mdbRow, mdbCol, mdbBtn } from "mdbvue";

export default {
  name: "CouponPreviewBenefit",
  components: { mdbRow, mdbCol, mdbBtn },
  props: {
    benefit: Object,
  },
  data() {
    return {
    };
  },
  methods: {
    getCodeText() {
      if (this.benefit.benefitcode === 1)
        return this.$t("benefit_copy_code") + "003FT4X3";
      if (this.benefit.benefitcodegeneric.length > 0)
        return this.$t("benefit_copy_code") + this.benefit.benefitcodegeneric;
    },
    getRestrictionText() {
      return this.benefit.restrictions;
    },
    getBenefitTitle() {
      return this.benefit.benefittitle;
    },
    getBenefitText() {
      return this.benefit.benefittext;
    },
    getValidityText() {
      var from = new Date(this.benefit.fromdate);
      var to = new Date(this.benefit.todate);
      return (
        this.$t("benefit_validuntil") +
        from.toLocaleDateString("fi-FI") +
        " - " +
        to.toLocaleDateString("fi-FI")
      );
    },
    getBenefitButtonText() {
      if (this.benefit.benefitbuttontext.length > 0) {
        return this.benefit.benefitbuttontext;
      }
      else if (this.benefit.coupontype == "ONCE") {
        return this.$t("benefit_button_once");
      } else if (this.benefit.coupontype == "ALWAYS") {
        return this.$t("benefit_button_always");
      } else if (this.benefit.coupontype == "WEB") {
        return this.$t("benefit_button_web");
      } else if (this.benefit.coupontype == "TABLERESERVATION") {
        return this.$t("benefit_button_tablereservation");
      }
    },
  },
  mounted() {

  },
};
</script>

<style scoped>
.btn {
  font-size: 20px;
}
p {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}
</style>
